/**
 * Staff account domain validation.
 * Staff accounts are restricted to Resolute-owned domains.
 */

export const STAFF_DOMAINS = ["resoluteink.co.uk", "resolute.ink"] as const;

/**
 * Check if an email belongs to a staff domain.
 * @param email - The email address to check
 * @returns true if the email domain is in STAFF_DOMAINS (case-insensitive)
 */
export function isStaffEmail(email: string): boolean {
  if (!email || typeof email !== "string") return false;
  const domain = email.split("@")[1]?.toLowerCase();
  return STAFF_DOMAINS.includes(domain as any);
}

/**
 * Staff account promotion:
 * To create a staff user, sign them up normally via the customer signup flow,
 * then in Supabase run:
 * UPDATE profiles SET role = 'staff' WHERE email = 'someone@resoluteink.co.uk';
 *
 * Staff accounts are never auto-promoted based on email domain alone.
 *
 * Audit staff roles in Supabase:
 * SELECT id, email, role FROM profiles WHERE email ILIKE '%@resoluteink.co.uk' OR email ILIKE '%@resolute.ink';
 */
